export default "#define GLSLIFY 1\n// And a standard vertex shader\nattribute vec4 position;\n\nvoid main() {\n  gl_Position = position;\n}\n";